import cx from 'classnames';
import { func, node, oneOf, string } from 'prop-types';
import React, { Children } from 'react';
import { Stack } from '../../Layout/index';
import useControlProp from '../../../hooks/useControlProp';
import useMedia from '../../../hooks/useMedia';
import Select from '../../Select/index';
import style from './VerticalTabbing.module.scss';

const VerticalTabbing = ({ children, space, alignItems, tab, onChange, defaultTab, ...rest }) => {
  const isMobile = useMedia('(max-width: 600px)');
  // eslint-disable-next-line no-shadow
  const tabItems = Children.toArray(children).map(({ props: { name, children } }) => ({
    name,
    children,
  }));

  const [tabState, setCurrentTab] = useControlProp(tab, onChange, defaultTab);
  const currentTab = tabItems.find(t => t.name === tabState)?.name ?? tabItems[0].name;

  const tabbing = (
    <React.Fragment>
      <div {...rest}>
        {isMobile ? (
          <Select
            value={currentTab}
            onChange={({ target }) => setCurrentTab(target.value)}
            className={style.select}
          >
            {tabItems.map(({ name }) => (
              <option value={name} key={name}>
                {name}
              </option>
            ))}
          </Select>
        ) : (
            <Stack gap="xsmall">
              {tabItems.map(({ name }) => (
                <div className={style.navItems} key={name} onClick={() => setCurrentTab(name)}>
                  <button
                    type="button"
                    className={cx(style.tab, currentTab === name && style.checked)}
                  >
                    {name}
                  </button>
                </div>
              ))}
            </Stack>
          )}
      </div>
      <div>
        {tabItems.find(({ name }) => name === currentTab).children}
      </div>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      {!isMobile ? (
        <div className={cx(style.verticalTabbing, style[space], style[alignItems])}>{tabbing}</div>
      ) : (
          <Stack gap="xsmall">{tabbing}</Stack>
        )}
    </React.Fragment>
  );
};

export default VerticalTabbing;

VerticalTabbing.propTypes = {
  children: node.isRequired,
  space: oneOf(['medium', 'large']),
  alignItems: oneOf(['top', 'center']),
  tab: string,
  onChange: func,
  defaultTab: string,
};

VerticalTabbing.defaultProps = {
  space: 'large',
  alignItems: 'top',
  tab: undefined,
  onChange: undefined,
  defaultTab: undefined,
};
